import { FC, useState } from 'react';
import styles from './selectItem.module.scss';
import { SelectItemProps } from './selectItemTypes';
import { CheckBoxIcon, CheckBoxOutlineBlankIcon } from '../../uiLibraryImports';

const SelectItem: FC<SelectItemProps> = (props: SelectItemProps) => {
    const { name, displayName, onChange, isSelected = false } = props;

    const [isSelectedState, setIsSelectedState] = useState<boolean>(isSelected);

    const onSelect = e => {
        setIsSelectedState(!isSelectedState);
        onChange(e, name);
    };

    return (
        <div data-testid="select-item" className={styles['select-item']} onClick={onSelect}>
            {isSelectedState ? (
                <CheckBoxIcon fontSize={'medium'} htmlColor={'#BAA7D8'} />
            ) : (
                <CheckBoxOutlineBlankIcon fontSize={'medium'} htmlColor={'#D7D8DB'} />
            )}
            <span className={styles.title}>{displayName}</span>
        </div>
    );
};

export default SelectItem;
